import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import { ButtonProps } from '@material/react-button';
import { OnToggleGrid } from '../_actions/ToolsActions';
import GridButton, { Props } from '../_components/GridButton';

const mapStateToProps = (store:Store, props:Props) => ({
	enabled: store.getIn(['create','tools','grid','enabled']),
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	onClick: () => dispatch(OnToggleGrid())
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(GridButton);